import type {
  LayoutImage,
  TypeAlignContent,
  TypeBackground,
  TypeStyle,
  srcSet,
} from '@/components/types';
import type { TypeContainerGraphQL } from '@/lib/graphql/types/common/container';

interface TypePartialContainer
  extends TypeBackground,
    TypeAlignContent,
    TypeStyle {}

export const containerTransformer = (
  container: TypeContainerGraphQL
): TypePartialContainer => {
  const SRCSet = container?.srcset ?? [];
  const baseImage = container?.imagenBase?.sourceUrl as string;
  const layoutImages: Array<srcSet> = [];

  SRCSet?.map((image: LayoutImage) => {
    layoutImages.push({
      media: image.anchura,
      src: image.imagen?.sourceUrl,
    });
  });

  return {
    ...(container?.imagenBase
      ? container?.imagenBase?.sourceUrl
        ? {
            backgroundImage: {
              src: baseImage,
              srcset: layoutImages,
              alt: container?.imagenBase?.altText,
            },
          }
        : {
            backgroundImage: baseImage,
          }
      : {}),
    ...(container?.colorDeFondo
      ? { style: { backgroundColor: container?.colorDeFondo } }
      : {}),
    ...(container?.overlay ? { overlay: container?.overlay / 100 } : {}),
    ...(container?.justify
      ? {
          justify: container?.justify.reduce(
            (previousValue: string, currentValue: any) =>
              `${previousValue} ${
                currentValue.mediaQuery === 'none'
                  ? currentValue.justify
                  : `${currentValue.mediaQuery}:${currentValue.justify}`
              }`,
            ''
          ),
        }
      : {}),
    ...(container?.align
      ? {
          align: container?.align.reduce(
            (previousValue: string, currentValue: any) =>
              `${previousValue} ${
                currentValue.mediaQuery === 'none'
                  ? currentValue.align
                  : `${currentValue.mediaQuery}:${currentValue.align}`
              }`,
            ''
          ),
        }
      : {}),
    ...(container?.textAlign
      ? {
          textAlign: container?.textAlign.reduce(
            (previousValue: string, currentValue: any) =>
              `${previousValue} ${
                currentValue.mediaQuery === 'none'
                  ? currentValue.textAlign
                  : `${currentValue.mediaQuery}:${currentValue.textAlign}`
              }`,
            ''
          ),
        }
      : {}),
  };
};
